import React, { useEffect, useState } from "react";
import { useTableContext } from "../../context/TableContext";
import { getFullPathOfField } from "../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/NewDesktopRecordviewRenderer";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "./TableTreeModal";
import MaterialIcon from "./MaterialIcon";
import { getToolTipAttributes } from "../../utils/tooltip";

const FieldSelectorFromPopup = ({
  label = "Select Field",
  tableId,
  tableType,
  tableMap = null,
  onSelect,
  id = "",
  fieldId = "",
  showDeleteButton = true // new prop
}) => {
  const initialModalState = {
    show: false,
    modalName: ""
  };
  const [isFieldModalOpen, setIsFieldModalOpen] = useState(initialModalState);
  const [tableObj, setTableObj] = useState(null);
  const { getTableTypeData } = useTableContext();
  const [selectedField, setSelectedField] = useState("");

  const openModal = () => {
    setIsFieldModalOpen({ show: true, modalName: "Select Field" });
  };

  const closeModal = () => {
    setIsFieldModalOpen(initialModalState);
  };

  const handleSingleFieldAddChange = (f) => {
    closeModal();
    onSelect(f);
    setSelectedField(f.id);
  };

  const deleteField = () => {
    setSelectedField("");
    onSelect({});
  };

  useEffect(() => {
    const fetchTable = async () => {
      try {
        if (tableMap) {
          setTableObj(tableMap);
        } else {
          let { tableObject } = await getTableTypeData(tableType, tableId);
          setTableObj(tableObject);
        }
      } catch (error) {
        setTableObj({});
      }
    };
    setSelectedField(fieldId);
    if (!fieldId || tableObj) return;
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableId, tableType, id, fieldId]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        className="builder_input"
        {...getToolTipAttributes(getFullPathOfField(selectedField, tableObj))}
        onClick={openModal}
      >
        {tableObj && selectedField ? `${tableObj[selectedField]?.display || label}` : label}
        {/* {selectedField ? getFullPathOfField(selectedField, tableObj) : label} */}
      </div>
      {selectedField &&
        showDeleteButton && ( // conditionally show delete
          <MaterialIcon
            name="close"
            className="cursor_pointer"
            style={{ position: "absolute", top: "50%", transform: "translateY(-50%)", right: "4px" }}
            onClick={deleteField}
          />
        )}
      <BuilderModal isOpen={isFieldModalOpen.show} onClose={closeModal} modalName="Select Field">
        <TableTreeModal callbackFunction={handleSingleFieldAddChange} tableId={tableId} tableType={tableType} />
      </BuilderModal>
    </div>
  );
};

export default FieldSelectorFromPopup;
